<template>
<div class="main-in">
    <div class="container" v-cloak>
        <div is='titlebox' :nav='JSON.parse(nav)'></div>
        <div class="content">
            <!-- <div class="left-corner">
                 <div class="card-header f-row-l">
                    <div class="bg-title1 f-row-c bbact">{{title}}</div>
                </div>
            </div> -->
            <div class="min-h">
                <div class="f-row-l align-start">
                    <div class="navbox">
                        <div class="defbtn bb-1" :class="ind==act?'brief':''" v-for='(item,ind) in brief2' :key="ind" @click="btn(ind)">{{item.label}}</div>
                    </div>
                    <div :class="brief2.length>0?'words-r':'w-100'">
                        <div class="mt12" v-if='this.$route.query.type<4'>
                            <!-- {{$imgUrl+info.logo}} -->
                             <div class="imgbox1 f-row-c"  v-if='isImage(info.logo)=="image"'>
                                <el-image fit='contain' class="img" :src="info.logo?$fileAccessHttpUrl(info.logo):require('@/assets/img/banner@2x.png')"></el-image>
                            </div>
                            <div class="imgbox1 f-row-c"  v-if='isImage(info.logo)=="video"'>
                                <video class="img" :src="$fileAccessHttpUrl(info.logo)" controls></video>
                            </div>
                            <div class="imgbox f-row-c"  v-if='isImage(info.logo)=="radio"'>
                                 <audio autoplay controls loop :src='$fileAccessHttpUrl(info.logo)'></audio>
                            </div>
                            <div v-if='info.logo' class="downbox f-row-c">
                                <span class="downicon pinter" @click="openUrl($fileAccessHttpUrl(info.logo))">
                                附件下载
                                </span>
                            </div>
                            <div v-html="info.content"></div>

                            <div v-if='info.file&&info.file.length>0' class="downbox">
                                <span class="downicon pinter" v-for='(item,ind) in info.file' :key='ind' :title="item" @click="openUrl($fileAccessHttpUrl(item))">
                                附件下载
                                </span>
                            </div>
                        </div>
                       <div class="mt12" v-else>
                           <div class="title f-row-c">{{info.leagueTitle}}</div>
                           <div>
                               <div v-html="info.leagueContent"></div>
                           </div>
                           <div v-if='info.leagueFile&&info.leagueFile.length>0' class="downbox">
                                <span class="downicon pinter" v-for='(item,ind) in info.leagueFile' :key='ind' :title="item" @click="openUrl($fileAccessHttpUrl(item))">
                                附件下载
                                </span>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>
<script>
export default {
    computed:{
        nav:function(){
            var arr=[]
            if(this.$route.query.type==4){
                arr=[
                    {
                        label:this.title,
                        path:'/regiment/list',
                        type:this.$route.query.type
                    },
                    {
                        label:this.title+'详情',
                        path:'/regiment/index',
                        type:this.$route.query.type,
                        id:this.$route.query.id,
                    },
                ]


            }else{
                arr=[
                    {
                        label:this.title,
                        path:'/regiment/index',
                        type:this.$route.query.type,
                        id:this.$route.query.id,
                    },
                ]
            }

            return JSON.stringify(arr)
        }
    },
    data(){
        return{
            info:{},
            brief2:[],
            type:this.$route.query.type,
            title:'',
            classType:1,
        }
    },
     mounted(){
        this.typeIs();
    },
    watch:{
        $route(to,from,next){
            if(to.path.indexOf('/regiment/index')!=-1){
                this.type=this.$route.query.type;
                this.typeIs();
            }
        },
    },
    methods: {
        isImage(fileName) {//判断是否时图片
            // 后缀获取
            var suffix = ''
            // 获取类型结果
            var result = ''
            try {
                var flieArr = fileName.split('.')
                suffix = flieArr[flieArr.length - 1]
            } catch (err) {
                suffix = ''
            }
            // fileName无后缀返回 false
            if (!suffix) {
                result = false
                return result
            }
            // 图片格式
            var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
            // 进行图片匹配
            result = imglist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'image'
                return result
            }
            // 匹配txt
            var txtlist = ['txt']
            result = txtlist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'txt'
                return result
            }
            // 匹配 excel
            var excelist = ['xls', 'xlsx']
            result = excelist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'excel'
                return result
            }
            // 匹配 word
            var wordlist = ['doc', 'docx']
            result = wordlist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'word'
                return result
            }
            // 匹配 pdf
            var pdflist = ['pdf']
            result = pdflist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'pdf'
                return result
            }
            // 匹配 ppt
            var pptlist = ['ppt']
            result = pptlist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'ppt'
                return result
            }
            // 匹配 视频
            var videolist = ['mp4', 'm2v', 'mkv']
            result = videolist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'video'
                return result
            }
            // 匹配 音频
            var radiolist = ['mp3', 'wav', 'wmv']
            result = radiolist.some(function (item) {
                return item == suffix
            })
            if (result) {
                result = 'radio'
                return result
            }
            // 其他 文件类型
            result = 'other'
            return result
        },
        openUrl(url){
            window.open(url)
        },
        typeIs(){
           switch(this.type*1){
                case 1:
                    this.title='团旗';
                    this.classType=1
                break;
                case 2:
                    this.title='团歌';
                    this.classType=3
                break;
                case 3:
                    this.title='团徽';
                    this.classType=2
                break;
                case 4:
                    this.title='团章';
                    // this.classType=4
                break;
            }
            if(this.$route.query.type=='4'){
                this.getInfoById()
            }else{
                this.getInfo();
            }

        },
        getInfoById(){
            this.info={}
            this.$get(`/web/home/queryById?id=${this.$route.query.id}`).then(res=>{
               this.info=res.result;
               if(res.result.leagueFile){
                   this.info.leagueFile=res.result.leagueFile.split(',')
               }
            })
        },
        getInfo(){
            this.info={}
            this.$get(`/web/home/queryConfig?type=${this.classType}`).then(res=>{
               this.info=res.result;
               if(res.result.file){
                   this.info.file=res.result.file.split(',')
               }
            })
        },
    },


}
</script>
<style lang="scss" scoped>

.content{
    position: relative;
    background-color: #fff;
    padding: 30px 50px;
    font-size: 16px;
    .left-corner {
        line-height: 5px;
        border-bottom: #d6dde6 1px solid;
    }
    ul {
        width: 100%;

        li{
            width: 100%;
            list-style: none;
            text-align: left;
            display: inline-block;
            line-height: 25px;
            padding-bottom:15px;
            border-bottom: 1px dashed #E0E0E0 ;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
                span{
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #999999;
                    position: absolute;
                    right: 60px;
                }
        }
    }
    .block{
        text-align: center;
        line-height: 50px;
        margin-top: 20px;
    }
}
.downbox{
    margin: 30px 50px 50px;
    font-size: 16px;
    color: #E61F26;
    .downicon{
    position: relative;
    display: inline-block;
    padding-left: 22px;
    padding-bottom: 20px;
    margin-right: 30px;
  }
  .downicon::before{
    content: '';
    width: 18px;
    height: 20px;
    position: absolute;
    left: 0px;
    background: url('../../assets/img/index/tuanzhang.png') no-repeat center/100% auto;
  }
}
.imgbox{
    width: 100%;
    height: 200px;
    .img{
        max-width: 100%;
        max-height: 100%;
    }
}
.imgbox1{
    width: 100%;
    // height: 300px;

    .img{
        // max-width: 100%;
        // max-height: 100%;
        height: 400px;
        width: 600px;
    }
}
.title{
    font-size: 28px;
}
</style>
